import { translatedFieldQuery } from '@pkg/sanity-utils/translatedFieldQuery';
import groq from 'groq';

export const blockPeopleListFields = groq`
    people[]->{
      ...,
      ${translatedFieldQuery("jobTitle")}
    }
`;
